/** @jsxImportSource @emotion/react */
import { styles } from './JobsFilters.styles';

export default function JobsFilters({
  filters,
  setFilters,
  skills,
  locations,
  types,
}: any) {
  function toggle(key: string, value: string) {
    const current = filters[key] || [];

    const next = current.includes(value)
      ? current.filter((v: string) => v !== value)
      : [...current, value];

    setFilters({
      ...filters,
      [key]: next,
    });
  }

  function render(title: string, key: string, values: any[]) {
    if (!Array.isArray(values) || values.length === 0) return null;

    return (
      <div css={styles.group}>
        <h4>{title}</h4>

        <div css={styles.chips}>
          {values.map(v => {
            const code = v?.code ?? v;
            const name = v?.name ?? v;

            if (!code) return null;

            const active = filters[key]?.includes(code);

            return (
              <button
                key={code}
                css={[styles.chip, active && styles.active]}
                onClick={() => toggle(key, code)}
              >
                {name || '—'}
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <aside css={styles.wrapper}>
      {render('Location', 'location', locations)}
      {render('Type', 'type', types)}
      {render('Skills', 'skills', skills)}
    </aside>
  );
}
